(ns app.front.view.escrow.account-list
  (:require [app.domain.fee.escrow-model :as escrow-model]
            [app.front.entities :as entities]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-my-accounts
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :fee.escrow/get-my-accounts
                 :method     :get
                 :on-success [::entities/override-entity-db]}]}))

(rf/reg-sub ::accounts
  (fn [[_ owner-id]]
    (rf/subscribe [::entities/entities {:escrow-account/owner owner-id}]))
  (fn [accounts _]
    (some->> accounts
             seq
             (sort-by :entity/created))))

(defn account-list [{:keys [tr owner-entity-id]}]
  (when-let [accounts (<sub [::accounts owner-entity-id])]
    [section/section
     :escrow-accounts
     {:tr tr}
     (tr [:escrow/escrow-accounts])
     [ui-table/modern-responsive-table
      (util/mmap {:cols  [[(tr [:escrow-account/id])
                           escrow-model/account-number]
                          [(tr [:escrow-account/municipality])
                           #(-> % :entity/parent :group/name)]
                          [(tr [:escrow-account/balance])
                           #(futil/money-string-whole-units (:escrow-account/balance %)
                                                            (-> % :entity/parent :group/currency))]]
                  :items accounts
                  :link  {:description (tr [:escrow/view-account])
                          :make-href   #(href/href :view/escrow-account.outstanding-payments
                                                   {:account-id (:db/id %)})}}
                 tr)]]))
